<ion-toolbar class="header-content">
  <div slot="start"
       class="logo-container x5-buttons"
       >
    <span class="flex-row">
      <span class="logo"></span>
      <span class="logo-text">
        <p class="h1">Promo</p>
        <p class="h1">Portal</p>
      </span>
    </span>
    <span title="{{title | uppercase}}"
          class="title ellipsis fadeInDown delay-0s5">
      {{title | uppercase}}
    </span>
  </div>

  <ion-buttons  slot="end">
    <span *ngFor="let button of getButtons(); let i = index"
          class="button-container fadeInRight delay-0s{{i + 3}}">
      <ion-button (click)="onMenuButtonClick(button.url)"
                  shape="round"
                  class="nav-button {{button.class}}"
                  [ngClass]="{'nav-active': isActivePage(button.id)}">
        <i class="fas icon" [ngClass]="button?.icon"></i>
      </ion-button>
      <ion-badge *ngIf="isBudgeShowed(button.id) && (getButtonBadgeCount(button) | async)"
                 class="badge"
                 [class.active]="button.badgeActive">
        {{getButtonBadgeCount(button) | async}}
      </ion-badge>
    </span>
  </ion-buttons>
</ion-toolbar>
